import React from 'react';
import type { GasOrderStatus } from '@tucupet/shared';

const META: Record<GasOrderStatus, { label: string; bg: string; fg: string }> = {
  pending_payment: { label: 'Por pagar', bg: 'var(--surface-2)', fg: 'var(--text-3)' },
  paid: { label: 'Pagado', bg: 'color-mix(in oklab, oklch(0.78 0.16 70) 14%, transparent)', fg: 'oklch(0.78 0.16 70)' },
  fulfilled: { label: 'Entregado', bg: 'color-mix(in oklab, var(--accent) 14%, transparent)', fg: 'var(--accent)' },
  cancelled: { label: 'Cancelado', bg: 'color-mix(in oklab, var(--danger) 14%, transparent)', fg: 'var(--danger)' },
  expired: { label: 'Expirado', bg: 'color-mix(in oklab, var(--danger) 14%, transparent)', fg: 'var(--danger)' },
};

export function GasStatusBadge({ status }: { status: GasOrderStatus }) {
  const m = META[status] ?? META.pending_payment;
  return (
    <span className="mono" style={{ fontSize: 11, padding: '3px 8px', borderRadius: 999, background: m.bg, color: m.fg, letterSpacing: '0.06em' }}>
      {m.label.toUpperCase()}
    </span>
  );
}
